<template lang="pug">

  v-form
    h3.text-center.font-weight-bold( :class='fondo_claro ? "azul--text" : " white--text"') ¿TIENES ALGUNA CONSULTA SOBRE NUESTRAS LÍNEAS COMERCIALES?
    h4.text-center.font-weight-regular( :class='fondo_claro ? "azul--text" : " white--text"') SÓLO DÉJANOS UN MENSAJE
      v-form(v-model='validación' autocomplete='false')  
        v-row(justify='center' align='start').fill-height.pa-4.my-12
          v-col(cols=12 sm=6)         
            v-text-field(:dark='!fondo_claro' color='azul' :rules='[requerido]' v-model='información.Nombre' label='NOMBRE:' single-line='' )
            v-text-field(:dark='!fondo_claro' color='azul' :rules='[requerido]' v-model='información.Empresa' label='EMPRESA:' single-line='' )
            v-text-field(:dark='!fondo_claro' color='azul' :rules='[requerido, correo_electronico]' v-model='información["Correo electrónico"]'  label='E-MAIL:' single-line='' )
            v-text-field(:dark='!fondo_claro' color='azul' :rules='[requerido]'  v-model='información.telefono' label='TELÉFONO:' single-line='')
          v-col(cols=12 sm=6)      
            v-textarea( outlined :dark='!fondo_claro' v-model='información.Mensaje' :rules='[requerido]'   color='black' label='MENSAJE:' single-line=''  )
            span( :class='fondo_claro ? "azul--text" : " white--text"' ).font-weight-bold ¿CÓMO TE ENTERASTE DE NOSOTROS?
            v-row(justify='space-around' )
              v-checkbox(:dark='!fondo_claro' v-model='información["Forma de contacto"]' color='azul' small value='Redes Sociales' label='Redes Sociales' )
              v-checkbox(:dark='!fondo_claro' v-model='información["Forma de contacto"]' color='azul' small value='Publicidad impresa' label='Publicidad impresa')
              v-checkbox(:dark='!fondo_claro' v-model='información["Forma de contacto"]' color='azul' small value='Recomendación' label='Recomendación')
          v-btn(:loading='enviando_correo' :color='!fondo_claro ? "white" : "rojo"' outlined :disabled='!validación || información["Forma de contacto"].length == 0' @click='enviar()' ) ENVIAR


</template>

<script>
import { enviar_correo_electronico } from '@/FirebaseConfig'
import { mapState } from 'vuex'
export default {
  data: ()=>({
    
    información: {
      "Forma de contacto": [],
    },
    validación: false,
    enviando_correo: false
  }),
  computed: {
    Contacto() {
      return this.$contenido.Contacto || {}
    },
    ...mapState({
      Reglas: ({Ayudas})=>Ayudas.reglas,
      
    }),
  },
  methods:{
    enviar(){
      const {credenciales, formato_de_correo} = this.Contacto
      const {firma, cuerpo, asunto} = formato_de_correo
      const correo_electronico = this.información["Correo electrónico"]
      let contenido = `${cuerpo}
      <table>`
      Object.keys(this.información).map( i => contenido+='<tr><td>' + i + '</td><td>' + this.información[i] + '</td></tr>')
      contenido += `</table>`
      this.enviando_correo = true
      enviar_correo_electronico({correo_electronico, asunto, contenido, firma, credenciales}).then( () => this.enviando_correo = false)
    }
  },
  props:{
    fondo_claro: Boolean
  }
}
</script>